module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/logos-b5a16fbed3b8957b540dfdbbd66803ea.svg";